export default {
  en: {
    title: 'Error breakdown',
    loadError: 'Couldn’t load the breakdown. Try again.',
    noErrors: 'No errors found — great job!',
    loadingBreakdown: 'Loading error breakdown',
    deleteAria: 'Delete: {{original}}',
  },
  ru: {
    title: 'Объяснение ошибок',
    loadError: 'Не получилось загрузить разбор. Попробуй ещё раз.',
    noErrors: 'Ошибок не найдено — всё отлично!',
    loadingBreakdown: 'Загружаю разбор ошибок',
    deleteAria: 'Удалить: {{original}}',
  },
  de: {
    title: 'Fehleranalyse',
    loadError: 'Die Analyse konnte nicht geladen werden. Versuch es noch mal.',
    noErrors: 'Keine Fehler gefunden — gute Arbeit!',
    loadingBreakdown: 'Fehleranalyse wird geladen',
    deleteAria: 'Löschen: {{original}}',
  },
  pt: {
    title: 'Análise de erros',
    loadError: 'Não foi possível carregar a análise. Tente de novo.',
    noErrors: 'Nenhum erro encontrado — muito bem!',
    loadingBreakdown: 'Carregando análise de erros',
    deleteAria: 'Excluir: {{original}}',
  },
  fr: {
    title: 'Analyse des erreurs',
    loadError: 'Impossible de charger l’analyse. Réessaie.',
    noErrors: 'Aucune erreur trouvée — bon travail !',
    loadingBreakdown: 'Chargement de l’analyse des erreurs',
    deleteAria: 'Supprimer : {{original}}',
  },
  es: {
    title: 'Análisis de errores',
    loadError: 'No se pudo cargar el análisis. Inténtalo de nuevo.',
    noErrors: 'No se encontraron errores — ¡buen trabajo!',
    loadingBreakdown: 'Cargando el análisis de errores',
    deleteAria: 'Eliminar: {{original}}',
  },
};
